import { Flex, FormLabel, Input } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { API } from "../../shared/Api/Api";
import { Context } from "../../shared/Context/Context";
import Loading from "../Loading/Loading";
import LoginButton from "../LoginButton/LoginButton";
import "./FormAddWinner.scss";

const FormAddWinner = ({ winners, setWinners }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const [loading, setLoading] = useState();
  const { tabletOrLess } = useContext(Context);

  const updateWinners = async (formData) => {
    setLoading(true);
    const objetcWinners = {
      data: await (
        await API.patch(`winners/${winners.data._id}`, formData)
      ).data.new,
    };
    setWinners(objetcWinners);
    reset();
    setLoading(false);
  };

  return (
    <form
      autoComplete="off"
      className="formAddWinner"
      onSubmit={handleSubmit(updateWinners)}
    >
      <Flex w="100%" justify="center" align="center" flexDir="column">
        <Flex w="100%" justify="center" align="center" flexWrap="wrap">
          <Flex
            justify="center"
            align="flex-start"
            flexDir="column"
            m="60px 100px"
            w="300px"
          >
            <FormLabel fontWeight="bold">
              Actualizar ganador de primaria
            </FormLabel>
            <Input
              border="none"
              backgroundColor="transparent"
              mt="15px"
              fontWeight="bold"
              p="8px"
              w={!tabletOrLess && "100%"}
              fontSize={!tabletOrLess && "larger"}
              borderBottom="3px solid black"
              _focus={{ outline: "none" }}
              placeholder="Ganador de primaria"
              {...register("winnerPrimaria", { required: true })}
            />
          </Flex>
          <Flex
            justify="center"
            align="flex-start"
            flexDir="column"
            m="60px 100px"
            w="300px"
          >
            <FormLabel fontWeight="bold">
              Actualizar ganador de secundaria
            </FormLabel>
            <Input
              border="none"
              backgroundColor="transparent"
              mt="15px"
              p="8px"
              fontWeight="bold"
              w={!tabletOrLess && "100%"}
              fontSize={!tabletOrLess && "larger"}
              borderBottom="3px solid black"
              _focus={{ outline: "none" }}
              placeholder="Ganador de secundaria"
              {...register("winnerSecundaria", { required: true })}
            />
          </Flex>
          <Flex
            justify="center"
            align="flex-start"
            flexDir="column"
            m="60px 100px"
            w="300px"
          >
            <FormLabel fontWeight="bold">Actualizar mes gratuito</FormLabel>
            <Input
              border="none"
              backgroundColor="transparent"
              mt="15px"
              p="8px"
              fontWeight="bold"
              w={!tabletOrLess && "100%"}
              fontSize={!tabletOrLess && "larger"}
              borderBottom="3px solid black"
              _focus={{ outline: "none" }}
              placeholder="Mes gratuito"
              {...register("mes", { required: true })}
            />
          </Flex>
        </Flex>
        <Flex justify="center" align="center">
          {loading ? (
            <Loading mini />
          ) : (
            <LoginButton texto="Actualizar Ganadores" />
          )}
        </Flex>
      </Flex>
    </form>
  );
};

export default FormAddWinner;
